import { render, staticRenderFns } from "./LoanAccountFollowed.vue?vue&type=template&id=0c451e0c&lang=true"
import script from "./LoanAccountFollowed.vue?vue&type=script&lang=js"
export * from "./LoanAccountFollowed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports